import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from '@/store'
import toasted from 'vue-toasted'
import echarts from 'echarts'
import Urls from '@/assets/js/Urls'

const ROOT = Urls.DOMAIN_YKT

Vue.prototype.$echarts = echarts

Vue.use(ElementUI)

Vue.use(toasted)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  ROOT,
  render: h => h(App)
}).$mount('#app')
